// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactFeather from "react-feather";
import * as Utils$Coronate from "../Utils.res.js";
import * as Router$Coronate from "../Router.res.js";
import * as Window$Coronate from "../Window.res.js";
import * as Data_Id$Coronate from "../Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageRound$Coronate from "./PageRound.res.js";
import * as Data_Match$Coronate from "../Data/Data_Match.res.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.res.js";
import * as Data_Player$Coronate from "../Data/Data_Player.res.js";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as HtmlEntities$Coronate from "../HtmlEntities.res.js";
import * as LoadTournament$Coronate from "./LoadTournament.res.js";
import * as PageTourneySetup$Coronate from "./PageTourneySetup.res.js";
import * as PageTourneyScores$Coronate from "./PageTourneyScores.res.js";
import * as PageTourneyPlayers$Coronate from "./PageTourneyPlayers.res.js";
import * as PageTournamentStatus$Coronate from "./PageTournamentStatus.res.js";

function PageTourney$Footer(props) {
  var tournament = props.tournament;
  var match = tournament.isNewRoundReady ? (
      tournament.isItOver ? [
          HtmlEntities$Coronate.nbsp + " All rounds have completed.",
          "Warning"
        ] : [
          HtmlEntities$Coronate.nbsp + " Ready to begin a new round.",
          "Success"
        ]
    ) : [
      HtmlEntities$Coronate.nbsp + "Round in progress.",
      "Generic"
    ];
  var tooltipText = match[0];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        "Rounds: ",
                        Data_Rounds$Coronate.size(tournament.tourney.roundList),
                        JsxRuntime.jsx("small", {
                              children: " out of "
                            }),
                        tournament.roundCount
                      ],
                      className: "win__footer-block"
                    }),
                JsxRuntime.jsx("hr", {
                      className: "win__footer-divider"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        "Registered players: ",
                        Belt_Map.size(tournament.activePlayers)
                      ],
                      className: "win__footer-block"
                    }),
                JsxRuntime.jsx("hr", {
                      className: "win__footer-divider"
                    }),
                JsxRuntime.jsx(Utils$Coronate.$$Notification.make, {
                      children: tooltipText,
                      kind: match[1],
                      tooltip: tooltipText,
                      className: "win__footer-block",
                      style: {
                        backgroundColor: "transparent",
                        color: "initial",
                        display: "inline-flex",
                        margin: "0",
                        minHeight: "initial"
                      }
                    })
              ]
            });
}

function noDraggy(e) {
  e.preventDefault();
}

function PageTourney$Sidebar(props) {
  var tournament = props.tournament;
  var tourney = tournament.tourney;
  var roundList = tourney.roundList;
  var setTourney = tournament.setTourney;
  var playersDispatch = tournament.playersDispatch;
  var players = tournament.players;
  var isItOver = tournament.isItOver;
  var activePlayers = tournament.activePlayers;
  var windowDispatch = props.windowDispatch;
  var newRound = function ($$event) {
    $$event.preventDefault();
    var confirmText = "All rounds have completed. Are you sure you want to begin a new one?";
    var confirmed = isItOver && !window.confirm(confirmText) ? false : true;
    if (confirmed) {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: Data_Rounds$Coronate.addRound(roundList)
                });
    }
    
  };
  var delLastRound = function ($$event) {
    $$event.preventDefault();
    if (!window.confirm("Are you sure you want to delete the last round?")) {
      return ;
    }
    RescriptReactRouter.push("#/tourneys/" + Data_Id$Coronate.toString(tourney.id));
    var lastRoundId = Data_Rounds$Coronate.getLastKey(roundList);
    var round = Data_Rounds$Coronate.get(roundList, lastRoundId);
    if (round !== undefined) {
      Belt_Array.forEach(Data_Rounds$Coronate.Round.toArray(Caml_option.valFromOption(round)), (function (match_) {
              if (!(match_.result !== "NotSet" && !Data_Match$Coronate.isBye(match_))) {
                return ;
              }
              var reset = function (id, rating) {
                var player = Belt_Map.get(players, id);
                if (player !== undefined) {
                  return playersDispatch({
                              TAG: "Set",
                              _0: player.id,
                              _1: Data_Player$Coronate.predMatchCount(Data_Player$Coronate.setRating(player, rating))
                            });
                }
                
              };
              reset(match_.whiteId, match_.whiteOrigRating);
              reset(match_.blackId, match_.blackOrigRating);
            }));
    }
    setTourney({
          id: tourney.id,
          name: tourney.name,
          date: tourney.date,
          playerIds: tourney.playerIds,
          scoreAdjustments: tourney.scoreAdjustments,
          byeQueue: tourney.byeQueue,
          tieBreaks: tourney.tieBreaks,
          roundList: Data_Rounds$Coronate.delLastRound(roundList)
        });
    if (Data_Rounds$Coronate.size(roundList) === 0) {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: Data_Rounds$Coronate.addRound(roundList)
                });
    }
    
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("nav", {
                      children: [
                        JsxRuntime.jsx("ul", {
                              children: JsxRuntime.jsx("li", {
                                    children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                          children: [
                                            JsxRuntime.jsx(ReactFeather.ChevronLeft, {}),
                                            JsxRuntime.jsx("span", {
                                                  children: " Back",
                                                  className: "sidebar__hide-on-close"
                                                })
                                          ],
                                          to_: "TournamentList",
                                          onDragStart: noDraggy,
                                          onClick: (function (param) {
                                              windowDispatch({
                                                    TAG: "SetSidebar",
                                                    _0: false
                                                  });
                                            })
                                        })
                                  }),
                              style: {
                                marginTop: "0"
                              }
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsxs("ul", {
                              children: [
                                JsxRuntime.jsx("li", {
                                      children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                            children: [
                                              JsxRuntime.jsx(ReactFeather.Settings, {}),
                                              JsxRuntime.jsx("span", {
                                                    children: " Setup",
                                                    className: "sidebar__hide-on-close"
                                                  })
                                            ],
                                            to_: {
                                              TAG: "Tournament",
                                              _0: tourney.id,
                                              _1: "Setup"
                                            },
                                            onDragStart: noDraggy,
                                            onClick: (function (param) {
                                                windowDispatch({
                                                      TAG: "SetSidebar",
                                                      _0: false
                                                    });
                                              })
                                          })
                                    }),
                                JsxRuntime.jsx("li", {
                                      children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                            children: [
                                              JsxRuntime.jsx(ReactFeather.Users, {}),
                                              JsxRuntime.jsx("span", {
                                                    children: " Players",
                                                    className: "sidebar__hide-on-close"
                                                  })
                                            ],
                                            to_: {
                                              TAG: "Tournament",
                                              _0: tourney.id,
                                              _1: "Players"
                                            },
                                            onDragStart: noDraggy,
                                            onClick: (function (param) {
                                                windowDispatch({
                                                      TAG: "SetSidebar",
                                                      _0: false
                                                    });
                                              })
                                          })
                                    }),
                                JsxRuntime.jsx("li", {
                                      children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                            children: [
                                              JsxRuntime.jsx(ReactFeather.Activity, {}),
                                              JsxRuntime.jsx("span", {
                                                    children: " Status",
                                                    className: "sidebar__hide-on-close"
                                                  })
                                            ],
                                            to_: {
                                              TAG: "Tournament",
                                              _0: tourney.id,
                                              _1: "Status"
                                            },
                                            onDragStart: noDraggy,
                                            onClick: (function (param) {
                                                windowDispatch({
                                                      TAG: "SetSidebar",
                                                      _0: false
                                                    });
                                              })
                                          })
                                    }),
                                JsxRuntime.jsx("li", {
                                      children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                            children: [
                                              JsxRuntime.jsx(ReactFeather.Layers, {}),
                                              JsxRuntime.jsx("span", {
                                                    children: " Crosstable",
                                                    className: "sidebar__hide-on-close"
                                                  })
                                            ],
                                            to_: {
                                              TAG: "Tournament",
                                              _0: tourney.id,
                                              _1: "Crosstable"
                                            },
                                            onDragStart: noDraggy,
                                            onClick: (function (param) {
                                                windowDispatch({
                                                      TAG: "SetSidebar",
                                                      _0: false
                                                    });
                                              })
                                          })
                                    }),
                                JsxRuntime.jsx("li", {
                                      children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                            children: [
                                              JsxRuntime.jsx(ReactFeather.List, {}),
                                              JsxRuntime.jsx("span", {
                                                    children: " Score detail",
                                                    className: "sidebar__hide-on-close"
                                                  })
                                            ],
                                            to_: {
                                              TAG: "Tournament",
                                              _0: tourney.id,
                                              _1: "Scores"
                                            },
                                            onDragStart: noDraggy,
                                            onClick: (function (param) {
                                                windowDispatch({
                                                      TAG: "SetSidebar",
                                                      _0: false
                                                    });
                                              })
                                          })
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsx("h5", {
                              children: "Rounds",
                              className: "sidebar__hide-on-close sidebar__header"
                            }),
                        JsxRuntime.jsx("ul", {
                              children: Belt_Array.mapWithIndex(Data_Rounds$Coronate.toArray(roundList), (function (id, param) {
                                      return JsxRuntime.jsx("li", {
                                                  children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                                        children: [
                                                          id + 1 | 0,
                                                          Data_Rounds$Coronate.isRoundComplete(roundList, activePlayers, id) ? JsxRuntime.jsxs("span", {
                                                                  children: [
                                                                    " Complete ",
                                                                    JsxRuntime.jsx(ReactFeather.Check, {})
                                                                  ],
                                                                  className: "sidebar__hide-on-close caption-20"
                                                                }) : JsxRuntime.jsxs("span", {
                                                                  children: [
                                                                    " Not complete ",
                                                                    JsxRuntime.jsx(ReactFeather.AlertTriangle, {})
                                                                  ],
                                                                  className: "sidebar__hide-on-close caption-20"
                                                                })
                                                        ],
                                                        to_: {
                                                          TAG: "Tournament",
                                                          _0: tourney.id,
                                                          _1: {
                                                            TAG: "Round",
                                                            _0: id
                                                          }
                                                        },
                                                        onDragStart: noDraggy,
                                                        onClick: (function (param) {
                                                            windowDispatch({
                                                                  TAG: "SetSidebar",
                                                                  _0: false
                                                                });
                                                          })
                                                      })
                                                }, String(id));
                                    })),
                              className: "center-on-close"
                            })
                      ]
                    }),
                JsxRuntime.jsx("hr", {}),
                JsxRuntime.jsxs("ul", {
                      children: [
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsxs("button", {
                                    children: [
                                      JsxRuntime.jsx(ReactFeather.Plus, {}),
                                      JsxRuntime.jsx("span", {
                                            children: " New round",
                                            className: "sidebar__hide-on-close"
                                          })
                                    ],
                                    className: "sidebar-button",
                                    style: {
                                      width: "100%"
                                    },
                                    disabled: !tournament.isNewRoundReady,
                                    onClick: newRound
                                  })
                            }),
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsxs("button", {
                                    children: [
                                      JsxRuntime.jsx(ReactFeather.Trash2, {}),
                                      JsxRuntime.jsx("span", {
                                            children: " Remove last round",
                                            className: "sidebar__hide-on-close"
                                          })
                                    ],
                                    className: "button-micro sidebar-button",
                                    style: {
                                      marginTop: "8px"
                                    },
                                    disabled: Data_Rounds$Coronate.size(roundList) === 0,
                                    onClick: delLastRound
                                  }),
                              style: {
                                textAlign: "center"
                              }
                            })
                      ]
                    })
              ]
            });
}

function PageTourney(props) {
  var windowDispatch = props.windowDispatch;
  var subPage = props.subPage;
  return JsxRuntime.jsx(LoadTournament$Coronate.make, {
              children: (function (tournament) {
                  var tmp;
                  if (typeof subPage !== "object") {
                    switch (subPage) {
                      case "Players" :
                          tmp = JsxRuntime.jsx(PageTourneyPlayers$Coronate.make, {
                                tournament: tournament
                              });
                          break;
                      case "Scores" :
                          tmp = JsxRuntime.jsx(PageTourneyScores$Coronate.make, {
                                tournament: tournament
                              });
                          break;
                      case "Crosstable" :
                          tmp = JsxRuntime.jsx(PageTourneyScores$Coronate.Crosstable.make, {
                                tournament: tournament
                              });
                          break;
                      case "Setup" :
                          tmp = JsxRuntime.jsx(PageTourneySetup$Coronate.make, {
                                tournament: tournament
                              });
                          break;
                      case "Status" :
                          tmp = JsxRuntime.jsx(PageTournamentStatus$Coronate.make, {
                                tournament: tournament
                              });
                          break;
                      
                    }
                  } else {
                    tmp = JsxRuntime.jsx(PageRound$Coronate.make, {
                          roundId: subPage._0,
                          tournament: tournament
                        });
                  }
                  return JsxRuntime.jsx(Window$Coronate.Body.make, {
                              children: tmp,
                              windowDispatch: windowDispatch,
                              footerFunc: (function () {
                                  return JsxRuntime.jsx(PageTourney$Footer, {
                                              tournament: tournament
                                            });
                                }),
                              sidebarFunc: (function (extra) {
                                  return JsxRuntime.jsx(PageTourney$Sidebar, {
                                              tournament: tournament,
                                              windowDispatch: extra
                                            });
                                })
                            });
                }),
              tourneyId: props.tourneyId,
              windowDispatch: windowDispatch
            });
}

var make = PageTourney;

export {
  make ,
}
/* react-feather Not a pure module */
